/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Arch_UniversalInputs */

const en_fc_dl_arch_universal = /** @type {(inputs: Fc_Dl_Arch_UniversalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universal (Apple silicon + Intel)`)
};

/**
* | output |
* | --- |
* | "Universal (Apple silicon + Intel)" |
*
* @param {Fc_Dl_Arch_UniversalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_arch_universal = /** @type {((inputs?: Fc_Dl_Arch_UniversalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Arch_UniversalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_arch_universal(inputs)
});
export { fc_dl_arch_universal as "fc.dl.arch.universal" }